import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cm_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-50 bg-white border border-border rounded-xl shadow-deep p-5"
          data-testid="cookie-banner"
        >
          <div className="flex items-start gap-3 mb-4">
            <span className="flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-lg bg-terra/10 text-terra">
              <Cookie className="w-4 h-4" />
            </span>
            <p className="text-sm leading-relaxed text-ink/80">
              Nous utilisons des cookies pour mesurer l'audience et améliorer votre expérience.
              Vous pouvez accepter ou refuser.{" "}
              <Link to="/politique-de-confidentialite" className="text-terra underline underline-offset-2 hover:text-terra-dark transition-colors duration-200" data-testid="cookie-privacy-link">
                En savoir plus
              </Link>
            </p>
          </div>
          <div className="flex gap-2.5">
            <button
              onClick={() => choose("accepted")}
              data-testid="cookie-accept-button"
              className="flex-1 bg-terra text-white font-sub text-sm font-medium px-4 py-2.5 rounded-full hover:bg-terra-dark transition-colors duration-200"
            >
              Accepter
            </button>
            <button
              onClick={() => choose("refused")}
              data-testid="cookie-refuse-button"
              className="flex-1 font-sub text-sm font-medium px-4 py-2.5 rounded-full border border-ink/20 hover:border-ink transition-colors duration-200"
            >
              Refuser
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
